import request from "@/utils/request";
import Qs from "qs";

// 物业服务列表
export function propertyList(data) {
  return request({
    url: "/property/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加物业服务
export function propertyAdd(data) {
  return request({
    url: "/property/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑物业服务
export function propertyEdit(data) {
  return request({
    url: "/property/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 查看物业服务
export function propertyInfo(data) {
  return request({
    url: "/property/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除物业服务
export function propertyDel(data) {
  return request({
    url: "/property/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 物业服务列表
export function get_property_service_lists(data) {
  return request({
    url: "/common/get_property_service_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 物业服务订单列表
export function order_lists(data) {
  return request({
    url: "/property/order_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 物业服务订单详情
export function order_info(data) {
  return request({
    url: "/property/order_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 取消物业服务订单
export function order_cancel(data) {
  return request({
    url: "/property/order_cancel",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 完成物业服务订单
export function order_finish(data) {
  return request({
    url: "/property/order_finish",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 物业服务评论列表
export function comment_lists(data) {
  return request({
    url: "/property/comment_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 物业服务评论详情
export function comment_info(data) {
  return request({
    url: "/property/comment_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 物业服务回复
export function comment_reply(data) {
  return request({
    url: "/property/comment_reply",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 物业、租赁费用列表
export function feeLists(data) {
  return request({
    url: "/property/fee_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加物业、租赁费用
export function feeAdd(data) {
  return request({
    url: "/property/fee_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑物业、租赁费用
export function feeEdit(data) {
  return request({
    url: "/property/fee_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 查看物业、租赁费用
export function feeInfo(data) {
  return request({
    url: "/property/fee_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除物业、租赁费用
export function feeDel(data) {
  return request({
    url: "/property/fee_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 修改物业、租赁费用状态
export function feeStatus(data) {
  return request({
    url: "/property/fee_change_status",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 导入物业、租赁费用
export function feeImport(data) {
  return request({
    url: "/property/fee_import",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 下载物业、租赁费用导入模板
export function feeTemplate(data) {
  return request({
    url: "/property/fee_import_template",
    method: "post",
    data: Qs.stringify(data),
  });
}